import React, { useCallback } from 'react';
import { CommandDefinition } from '../../../concepts/commands/CommandDefinition';
import { CommandRegistry } from '../../../concepts/commands/CommandRegistry';
import { TypeaheadInput, TypeaheadItem } from '../../../ui';
import { useResolve } from '../../Container';

export type CommandSelectorProps = {
    onSelect: (commandDef: CommandDefinition) => void,
};

export const CommandSelector = ({ onSelect }: CommandSelectorProps) => {

    const commands = useResolve(CommandRegistry);

    const commandSource = useCallback((value: string) => {
        return commands.suggest(value).map(x => TypeaheadItem(x.name, x.label));
    }, []);

    const onTypeaheadSelect = useCallback((tm: TypeaheadItem) => {
        onSelect(commands.get(tm.id));
    }, [onSelect]);

    return <TypeaheadInput
        compact
        placeholder="Search Commands"
        typeaheadSource={commandSource}
        onTypeaheadSelect={onTypeaheadSelect}
    />;
};
